import { reducers } from 'redux/core'
import request from 'sb-request'


const fetchItems = () =>
  request.post('rest/subscription/orders', {
    modifyResult: ({ items }) => {
      let newItems = []
      let date

      items.forEach((item) => {
        if (item.product) {
          item.products = [ item.product ]
          delete item.product
        }

        if (item.shippingDate !== date) {
          date = item.shippingDate
          newItems.push(item)
        }
        else {
          newItems = newItems.map((newItem) => {
            if (newItem.shippingDate === date) {
              newItem.products.push(item.products[0])
            }

            return newItem
          })
        }
      })

      return newItems
    },
  })
    .then((items) => reducers.view.ordersStatusPage.setItems(items))

const fetchOrders = () =>
  request.post('graphql?name=profileShipments', {
    body: {
      query: `{
        profileShipments {
          year
          month
          shippingDate
          tracking {
            id
            number: trackingNumber
            url: trackingUrl
            status
          }
          products {
            id
            image: img
            brand
            url
            name
            upchargePrice
          }
        }
      }`,
    },
    modifyResult: ({ profileShipments }) => profileShipments,
    // mock: true,
    // mockData: {
    //   profileShipments: [
    //     {
    //       year: 2018,
    //       month: 11,
    //       shippingDate: '2018-11-10T00:00:00Z',
    //       tracking: {
    //         trackingNumber: 'test trackingNumber',
    //         status: 'delivered',
    //       },
    //       products: [
    //         {
    //           id: 673,
    //           img: 'https://cdn.scentbird.com/perfume/normal/img-673.jpg',
    //           name: 'Bergamotto di Calabria',
    //           url: '/perfume/acqua-di-parma-bergamotto-di-calabria-1417633',
    //           brand: 'Acqua di Parma',
    //         },
    //       ],
    //     },
    //     {
    //       year: 2018,
    //       month: 10,
    //       shippingDate: '2018-10-10T00:00:00Z',
    //       tracking: null,
    //       products: [
    //         {
    //           id: 673,
    //           img: 'https://cdn.scentbird.com/perfume/normal/img-673.jpg',
    //           name: 'Bergamotto di Calabria',
    //           url: '/perfume/acqua-di-parma-bergamotto-di-calabria-1417633',
    //           brand: 'Acqua di Parma',
    //         },
    //       ],
    //     },
    //   ],
    // },
  })
    .then((items) => {
      reducers.view.ordersStatusPage.setItems(items)
    })

export default {
  fetchItems,
  fetchOrders,
}
